<main>
    <div class="row paragraph mt-3">
        <div class="col-12">
            <textarea class="col-12 mt-1 text-area" [(ngModel)]="costEstimatesData.description"
                (ngModelChange)="emitChanges()" placeholder="Description">
            </textarea>
        </div>
    </div>
</main>